import React from 'react';

import EventBanner from '../components/common/organism/EventBanner';
import PageTemplate from '../components/common/template/PageTemplate';

import useEvent from '../Hooks/useEvent';

const EventMainPage = () => {
  const { onGoingEventList, maskOnEventList, isEventItemOn } = useEvent();

  return (
    <PageTemplate title={PAGE_TITLE} noMargin>
      {[onGoingEventList].map((eventList) =>
        eventList.map((event) => {
          const {
            id,
            image,
            period: { startDate, endDate },
            url,
          } = event;
          return (
            <EventBanner
              key={id}
              id={id}
              image={image}
              isEventItemOn={isEventItemOn({
                startDate,
                endDate,
              })}
              url={url}
            />
          );
        }),
      )}
    </PageTemplate>
  );
};

export default EventMainPage;

const PAGE_TITLE = '이벤트';
